import { useMutation } from "@tanstack/react-query";
import type { AxiosError } from "axios";

import { mutationKeyMap } from "@/features/query-client";

import { inviteUser } from "../api";
import type { IInviteUserVariables } from "../types";

type IInviteUserMutationResult = Awaited<ReturnType<typeof inviteUser>>;

interface IInviteUserMutationVariables {
  lenderCompanyId: number;
  data: IInviteUserVariables;
}

export const useInviteUserMutation = () => {
  return useMutation<
    IInviteUserMutationResult,
    AxiosError,
    IInviteUserMutationVariables
  >({
    mutationKey: mutationKeyMap.inviteUser,
    mutationFn: async ({ lenderCompanyId, data }) => {
      return await inviteUser(lenderCompanyId, data);
    },
  });
};
